var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23535 0C7.88899 3.15013e-05 9.47523 0.642799 10.6445 1.78613C11.8136 2.92944 12.4707 4.47992 12.4707 6.09668C12.4707 9.90166 8.15396 13.8648 6.7041 15.0889C6.56908 15.1881 6.40428 15.2412 6.23535 15.2412C6.06638 15.2412 5.90165 15.1882 5.7666 15.0889C4.31688 13.8649 0 9.90178 0 6.09668C1.77852e-05 4.47987 0.657019 2.92945 1.82617 1.78613C2.9955 0.642771 4.58167 0 6.23535 0ZM6.35449 3.58301C4.82399 3.58301 3.58301 4.82399 3.58301 6.35449C3.58311 7.88491 4.82406 9.12598 6.35449 9.12598C7.88484 9.12588 9.12588 7.88484 9.12598 6.35449C9.12598 4.82406 7.88491 3.58311 6.35449 3.58301Z",
    fill: "#FF2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocCard);
export default __webpack_public_path__ + "static/media/locCard.65c09207a4ad7b5644b90b497de12478.svg";
export { ForwardRef as ReactComponent };